import Api from 'App/api'

export const getFeed = Api.get({
  controller: 'feed',
  action: 'getFeed',
})

export const getFeedWithSettings = Api.get({
  controller: 'feed',
  action: 'getFeedWithSettings',
})

export const getFeedSettings = Api.get({
  controller: 'feed',
  action: 'getSettings',
})

export const postFeedSettings = Api.post({
  controller: 'feed',
  action: 'saveSettings',
})
